import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edb0e47a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalContainer" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.loadingGif,
      alt: ""
    }, null, 8, _hoisted_2)
  ], 512)), [
    [_vShow, _ctx.isOpen]
  ])
}